/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setFlag } from '../../redux/flags/flags';
import { ReactComponent as ArrowTeam } from '../../styles/icon/arrow-team.svg';
import Main from '../../elements/Main/Main';
import Button from '../../elements/Button/Button';
import ContactForm from './ContactForm';
import FooterContainer from '../../components/FooterContainer/FooterContainer';
import './Contact.scss';
import { Image, HeadWrapper } from '../../elements';
import img_slide_1 from '../../styles/images/about/img-slide-1.jpeg';
import img_slide_1x2 from '../../styles/images/about/img-slide-1@2x.jpeg';
import img_slide_2 from '../../styles/images/about/img-slide-2.jpeg';
import img_slide_2x2 from '../../styles/images/about/img-slide-2@2x.jpeg';
import img_slide_5 from '../../styles/images/about/img-slide-5.jpeg';
import img_slide_5x2 from '../../styles/images/about/img-slide-5@2x.jpeg';
import { Swiper, SwiperSlide } from 'swiper/react';
import strings from '../../lang/lang';

const mapDispatchToProps = {
  setFlag,
};

const Contact = (props) => {
  const { setFlag } = props;
  useEffect(() => {
    setFlag('isHeaderContact', true);
    return () => {
      setFlag('isHeaderContact', false);
    };
  }, [setFlag]);
  return (
    <>
      <HeadWrapper
        href="https://developer.staq.io/contact"
        title="Contact us | Staq Developer Portal"
        description="Please share your information and allow our team to assist you. We're happy to answer your questions and walk you through our cutting-edge financial solutions."
      />
      <Main className="contact">
        <div className="contact__figure-bottom-left"></div>
        <div className="contact__figure-top-right"></div>
        <div className="contact contact--top">
          <ContactForm
            firstName={strings.contact.text.firstName}
            lastName={strings.contact.text.lastName}
            workEmail={strings.contact.text.workEmail}
            workPhone={strings.contact.text.workPhone}
          />
        </div>
      </Main>
      <div className="contact">
        <div className="contact__careers">
          <div className="contact__title">
            <h2>{strings.contact.text.titleH2}</h2>
            <p>
              {strings.contact.text.description}{' '}
              <a href="#">{strings.contact.text.descriptionLinkPart2}</a>{' '}
              {strings.contact.text.descriptionPart3}
            </p>
            <a className="contact__join" href="https://staq.io/careers/jobs" target="_blank">
              <Button name={strings.contact.text.btnJoin} type="button" variant="gradient_type2">
                <ArrowTeam />
              </Button>
            </a>
          </div>
          <div className="contact__slider-wrap">
            <Swiper
              className="contact__slider"
              spaceBetween={24}
              slidesPerView={3}
              centeredSlides={true}
              loop
              breakpoints={{ 767: { spaceBetween: 40, centeredSlides: false } }}
            >
              <SwiperSlide className="contact__slide">
                <Image
                  imgData={{ '1x': img_slide_5, '2x': img_slide_5x2, alt: 'image' }}
                  darkImgData={{ '1x': img_slide_5, '2x': img_slide_5x2, alt: 'image' }}
                />
              </SwiperSlide>
              <SwiperSlide className="contact__slide">
                <Image
                  imgData={{ '1x': img_slide_1, '2x': img_slide_1x2, alt: 'image' }}
                  darkImgData={{ '1x': img_slide_1, '2x': img_slide_1x2, alt: 'image' }}
                />
              </SwiperSlide>
              <SwiperSlide className="contact__slide">
                <Image
                  imgData={{ '1x': img_slide_2, '2x': img_slide_2x2, alt: 'image' }}
                  darkImgData={{ '1x': img_slide_2, '2x': img_slide_2x2, alt: 'image' }}
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
      <FooterContainer />
    </>
  );
};

export default connect(null, mapDispatchToProps)(Contact);
